import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app.tsx';
import { rehydrateConfig } from './config/env.ts';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element in index.html');

try {
  await rehydrateConfig();
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} catch (err) {
  const message = err instanceof Error ? err.message : String(err);
  console.error('[breeze] failed to bootstrap runtime config:', err);
  root.innerHTML = `
    <main role="alert" style="margin:2rem auto;max-width:40rem;font-family:system-ui;padding:1rem">
      <h1 style="font-size:1.25rem;font-weight:600">Breeze could not load its runtime configuration.</h1>
      <p style="font-size:0.875rem;color:#475569">${message}</p>
      <p style="font-size:0.875rem;color:#475569">Check the browser console for details.</p>
    </main>
  `;
}
